(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('professional-area', {
            parent: 'entity',
            url: '/professional-area?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'teJHipsterApp.professionalArea.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/professional-area/professional-areas.html',
                    controller: 'ProfessionalAreaController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('professionalArea');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('professional-area-detail', {
            parent: 'professional-area',
            url: '/professional-area/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'teJHipsterApp.professionalArea.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/professional-area/professional-area-detail.html',
                    controller: 'ProfessionalAreaDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('professionalArea');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'ProfessionalArea', function($stateParams, ProfessionalArea) {
                    return ProfessionalArea.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'professional-area',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('professional-area-detail.edit', {
            parent: 'professional-area-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/professional-area/professional-area-dialog.html',
                    controller: 'ProfessionalAreaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ProfessionalArea', function(ProfessionalArea) {
                            return ProfessionalArea.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('professional-area.new', {
            parent: 'professional-area',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/professional-area/professional-area-dialog.html',
                    controller: 'ProfessionalAreaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                areaId: null,
                                name: null,
                                description: null,
                                showInFaqList: null,
                                showInDocumentList: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('professional-area', null, { reload: 'professional-area' });
                }, function() {
                    $state.go('professional-area');
                });
            }]
        })
        .state('professional-area.edit', {
            parent: 'professional-area',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/professional-area/professional-area-dialog.html',
                    controller: 'ProfessionalAreaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ProfessionalArea', function(ProfessionalArea) {
                            return ProfessionalArea.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('professional-area', null, { reload: 'professional-area' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('professional-area.delete', {
            parent: 'professional-area',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/professional-area/professional-area-delete-dialog.html',
                    controller: 'ProfessionalAreaDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['ProfessionalArea', function(ProfessionalArea) {
                            return ProfessionalArea.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('professional-area', null, { reload: 'professional-area' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
